(() => {
  const CHANGE_INTERVAL = 1700;
  const FADE_TIME = 380;

  const productCache = new Map();

  function canonicalUrl(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin + parsed.pathname;
    } catch (e) {
      return url;
    }
  }


  /* ========================================
     商品ハンドルを取得
  ======================================== */

  function getProductHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');

    if (!link) return null;

    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);

      return match ? match[1] : null;
    } catch (e) {
      return null;
    }
  }


  /* ========================================
     バリエーション画像を取得
  ======================================== */

  async function getVariantImages(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const promise = fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Product data could not be loaded.');
        }

        return response.json();
      })
      .then((product) => {
        const images = [];
        const used = new Set();

        product.variants.forEach((variant) => {
          if (
            variant.featured_image &&
            variant.featured_image.src
          ) {
            const src = variant.featured_image.src;
            const key = canonicalUrl(src);

            if (!used.has(key)) {
              used.add(key);
              images.push(src);
            }
          }
        });


        /* 画像を先読み */

        images.forEach((src) => {
          const preload = new Image();
          preload.src = src;
        });

        return images;
      })
      .catch((error) => {
        console.warn(
          'SANCERA color hover:',
          error
        );

        return [];
      });


    productCache.set(handle, promise);

    return promise;
  }


  /* ========================================
     商品カードごとの処理
  ======================================== */

  function setupCard(card) {
    if (!card) return;

    if (
      card.dataset.sanceraColorHover === 'ready'
    ) {
      return;
    }


    const handle = getProductHandle(card);

    if (!handle) return;


    const image = card.querySelector(
      '.card__media .media img'
    );

    if (!image) return;


    card.dataset.sanceraColorHover = 'ready';


    /* 最初の商品画像を保存 */

    const originalSrc =
      image.getAttribute('src');

    const originalSrcset =
      image.getAttribute('srcset');

    const originalSizes =
      image.getAttribute('sizes');


    let timer = null;
    let fadeTimer = null;
    let restoreTimer = null;

    let currentIndex = 0;
    let images = [];

    let isHovering = false;
    let hoverToken = 0;


    image.style.transition =
      `opacity ${FADE_TIME}ms ease`;


    /* ========================================
       次の画像へフェード
    ======================================== */

    function showImage(src, token) {
      clearTimeout(fadeTimer);

      image.style.opacity = '0';


      fadeTimer = setTimeout(() => {

        /*
         マウスがすでに外れていたら
         画像変更しない
        */

        if (
          !isHovering ||
          token !== hoverToken
        ) {
          return;
        }


        image.removeAttribute('srcset');
        image.removeAttribute('sizes');

        image.src = src;

        image.style.opacity = '1';

      }, FADE_TIME);
    }


    /* ========================================
       マウスを乗せた時
    ======================================== */

    async function startCycle() {

      /*
       PCのマウス操作時のみ
      */

      if (
        !window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        ).matches
      ) {
        return;
      }


      isHovering = true;

      hoverToken += 1;

      const currentToken = hoverToken;


      clearTimeout(restoreTimer);
      clearTimeout(fadeTimer);


      /*
       すでに動いている場合は
       二重起動しない
      */

      if (timer) {
        return;
      }


      const variantImages =
        await getVariantImages(handle);


      /*
       読み込み中にマウスが外れた場合は
       何もしない
      */

      if (
        !isHovering ||
        currentToken !== hoverToken ||
        !card.matches(':hover')
      ) {
        return;
      }


      /*
       カラー画像が1種類しかない商品は
       動かさない
      */

      if (variantImages.length < 2) {
        return;
      }


      const originalKey =
        canonicalUrl(originalSrc);


      /*
       元画像を最初にして
       重複している画像を除外
      */

      images = [
        originalSrc,

        ...variantImages.filter(
          (src) =>
            canonicalUrl(src) !== originalKey
        )
      ];


      currentIndex = 0;


      timer = setInterval(() => {

        /*
         マウスが外れていたら停止
        */

        if (
          !isHovering ||
          !card.matches(':hover')
        ) {
          stopCycle();
          return;
        }


        currentIndex += 1;


        if (
          currentIndex >= images.length
        ) {
          currentIndex = 0;
        }


        showImage(
          images[currentIndex],
          currentToken
        );

      }, CHANGE_INTERVAL);
    }


    /* ========================================
       マウスを外した時
    ======================================== */

    function stopCycle() {

      isHovering = false;

      hoverToken += 1;


      clearInterval(timer);
      clearTimeout(fadeTimer);
      clearTimeout(restoreTimer);


      timer = null;

      currentIndex = 0;


      image.style.opacity = '0';


      restoreTimer = setTimeout(() => {

        /*
         もう一度マウスが乗っていたら
         元画像へ戻さない
        */

        if (isHovering) {
          return;
        }


        if (originalSrcset) {

          image.setAttribute(
            'srcset',
            originalSrcset
          );

        } else {

          image.removeAttribute(
            'srcset'
          );

        }


        if (originalSizes) {

          image.setAttribute(
            'sizes',
            originalSizes
          );

        } else {

          image.removeAttribute(
            'sizes'
          );

        }


        image.src = originalSrc;

        image.style.opacity = '1';

      }, FADE_TIME);
    }


    /* ========================================
       イベント
    ======================================== */

    card.addEventListener(
      'mouseenter',
      startCycle
    );


    card.addEventListener(
      'mouseleave',
      stopCycle
    );
  }


  /* ========================================
     商品カードをすべて設定
  ======================================== */

  function initSanceraColorHover() {

    document
      .querySelectorAll('.card-wrapper')
      .forEach(setupCard);

  }


  /* ========================================
     ページ読み込み時
  ======================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initSanceraColorHover
    );

  } else {

    initSanceraColorHover();

  }


  /* ========================================
     Shopifyテーマエディタ対応
  ======================================== */

  document.addEventListener(
    'shopify:section:load',
    initSanceraColorHover
  );

})();